import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type CustomWebState = {
    id: number | undefined;
};

const initialState: CustomWebState = {
    id: undefined,
};

export const customWebSlice = createSlice({
    name: 'customWeb',
    initialState,
    reducers: {
        create: (state, action: PayloadAction<number>) => {
            state.id = action.payload;
        },
    },
});

export default customWebSlice.reducer;
